// extracted by mini-css-extract-plugin
export default {"statusMenu":"StatusMenu_statusMenu__yxOMB","listItem":"StatusMenu_listItem__cnhql","link":"StatusMenu_link__hQzNY"};